import { ChangeDetectionStrategy, Component, HostBinding, input, Input } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'coin-icon-button',
  imports: [MatIconModule],
  templateUrl: './icon-button.component.html',
  styleUrl: './icon-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IconButtonComponent {
  @Input() disabled = false;
  @Input({ required: true }) icon: string;
  @Input() svgIcon: string;
  @Input({ required: true }) type: IconButtonType;
  iconSize = input<IconSize>('regular');

  @HostBinding('class')
  private get classes(): string {
    // currently using this name for legacy support, in the future use `type-${this.type}`
    return `${this.type} icon-${this.iconSize()}`;
  }
}

export const ICON_BUTTON_TYPES = ['primary', 'secondary', 'white', 'outline'] as const;
export type IconButtonType = (typeof ICON_BUTTON_TYPES)[number];
export const ICON_SIZES = ['regular', 'large'] as const;
export type IconSize = (typeof ICON_SIZES)[number];
